import { useRef, useState } from "react";
import { Camera, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function PhotoUploader({ onResult, disabled }) {
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef(null);

  const handlePick = () => {
    if (disabled || uploading) return;
    inputRef.current?.click();
  };

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (file.size > 10 * 1024 * 1024) {
      toast.error("Photo too large (max 10MB)");
      return;
    }
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("image", file);
      const r = await api.post("/vision/parse-receipt", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onResult?.(r.data);
      toast.success(`Logged ${r.data.transactions?.length || 0} entries from photo`);
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.detail?.slice(0, 80) || "Photo parsing failed");
    } finally {
      setUploading(false);
    }
  };

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        capture="environment"
        onChange={handleFile}
        className="hidden"
        data-testid="photo-input"
      />
      <button
        onClick={handlePick}
        disabled={disabled || uploading}
        className="w-10 h-10 rounded-full bg-accent text-kudi-green flex items-center justify-center hover:bg-accent/70 transition disabled:opacity-40"
        title="Snap a photo of receipt or ledger"
        data-testid="photo-upload-btn"
      >
        {uploading ? <Loader2 className="w-5 h-5 animate-spin" /> : <Camera className="w-5 h-5" />}
      </button>
    </>
  );
}
